import React from "react";
import styled from "styled-components";
import { Error, Hint } from "./styles";

export const CheckBoxContainerStyle = styled.div`
    flex-direction: row;
    display: flex;
    gap: 8px;
    width: 100%;
    align-items: center;
    border: ${(props) => (props.borderd ? "1px solid #c9cbcd" : "none")};
    padding: ${(props) => (props.borderd ? "15px 12px" : "0")};
    border-radius: 6px;
`;

export const CheckBoxDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    transform: ${(props) => (props.details ? "translateY(0px)" : "translateY(3px)")};
`;

export const StyledCheckBox = styled.input`
    :disabled {
        background-color: #d3dae6;
        border: 1px solid #98a2b3;
    }
`;
export const StyledCheckBoxLabel = styled.label`
    font-size: 1.2rem;
    color: black;
`;

export const StyledCheckBoxDetails = styled.p`
    font-weight: 400;
    font-size: 14px;
    color: #6b7280;
`;

function CheckBox({
    name,
    onChange,
    required,
    label,
    value,
    error,
    type,
    inputValue,
    details,
    borderd,
    disabled,
}) {
    return (
        <CheckBoxContainerStyle borderd={borderd}>
            <StyledCheckBox
                type={type || "checkbox"}
                name={name}
                onChange={onChange}
                checked={value}
                required={required}
                value={inputValue}
                disabled={disabled}
            />
            <CheckBoxDetailsContainer details={details}>
                <StyledCheckBoxLabel>{label}</StyledCheckBoxLabel>
                {details && <StyledCheckBoxDetails>{details}</StyledCheckBoxDetails>}
                <Hint>{error && required && <Error>please fill this field </Error>}</Hint>
            </CheckBoxDetailsContainer>
        </CheckBoxContainerStyle>
    );
}

export default CheckBox;
